import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_ATTACHMENT',
  CREATE: 'CREATE_ATTACHMENT',
  DELETE: 'DELETE_ATTACHMENT',
};

export const listAttachment = submission_id => ({
  type: ACTION.LIST,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_SUBMISSION_ATTACHMENT,
    params: {
      submission_id,
    },
  }).catch(err => Promise.reject(err.response.data.detail)),
});

export const createAttachment = (submission_id, file) => {
  const formData = new FormData();
  formData.set('submission_id', submission_id);
  formData.set('attachment', file);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_SUBMISSION_ATTACHMENT,
      data: formData,
    }).catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const deleteAttachment = id => ({
  type: ACTION.DELETE,
  payload: RestClient.request({
    method: 'delete',
    url: `${Constants.API_SUBMISSION_ATTACHMENT}${id}/`,
  })
    .then(() => ({ id }))
    .catch(err => Promise.reject(err.response.data.detail)),
});



// WEBPACK FOOTER //
// ./src/redux/project_inspection/submission_attachment_actions.js